export function SlideNumber(Splide, Components) {
  const { track } = Components.Elements;

  let slideNumberElement;

  function mount() {
    slideNumberElement = document.createElement('div');
    slideNumberElement.classList.add('splide-number');

    track.parentElement.insertBefore(slideNumberElement, track.nextSibling);

    update();
    Splide.on('move', update);
  }

  function update() {
    const currentIndex = `${Splide.index + 1}`.slice(-2);

    slideNumberElement.textContent = `${currentIndex} / ${Splide.length}`;
  }

  return {
    mount,
  };
}
